<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg">
  <ng-container *ngIf="consulta">
    <div class="body">
      <ng-container *ngFor="let r of consulta?.registros; let i = index">
        <h2 class="subtitle subtitle-{{status}}">{{i+1}} - {{r?.relacionamento}}</h2>
        <ul class="card-list-striped py-1">
          <li>
            <span class="text-secondary">CNPJ:</span>
            <span class="text-uppercase">{{ r?.cnpj || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">RAZÃO SOCIAL:</span>
            <span class="text-uppercase">{{ r?.razao_social || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">SITUAÇÃO:</span>
            <span class="text-uppercase">{{ r?.situacao || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">RELACIONAMENTO:</span>
            <span class="text-uppercase">{{ r?.relacionamento || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">PARTICIPAÇÃO:</span>
            <span class="text-uppercase">{{ r?.participacao || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">ENTRADA:</span>
            <span class="text-uppercase">{{ r?.entrada || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">ATUALIZAÇÃO:</span>
            <span class="text-uppercase">{{ r?.atualizacao || msgNull }}</span>
          </li>
        </ul>
      </ng-container>
    </div>
  </ng-container>
</app-card-consulta>